export const SERVICES_KIND = Object.freeze({
  MAINTENANCE: 'maintenance',
  REPAIR: 'repair',
  AUTO_RECALL: 'autorecall',
  DECLINED: 'declined',
  DEFERRED: 'deferred'
});

export const SERVICES_STATUS = Object.freeze({
  OPEN: 'open',
  NO_REMEDY: 'NO_REMEDY'
});

export const SERVICES_TYPE = Object.freeze({
  ALACARTE: 'Alacarte',
  MENU: 'Menu'
});



// WEBPACK FOOTER //
// ./src/constants/services.js